// modules
import { useEffect } from "react";

// components
import ConfirmModal from "components/molecules/ModalContainer/ModalContainer";

// constants
import { NewUser } from "constants/global";

export const useConfirmModal = ({ checked, handleEnable2FA }: { checked: boolean; handleEnable2FA: (x: boolean) => void }) => {
	useEffect(() => {
		!checked &&
			ConfirmModal({
				type: "confirm",
				closable: false,
				description: NewUser.DISABLE_MFA_WARNING_MESSAGE,
				actionButton: { label: "Continue", onClick: () => handleEnable2FA(false) },
				cancelButton: { label: "Go Back", onClick: () => handleEnable2FA(true) }
			});
	}, [checked]);
};
